module.exports = __webpack_public_path__ + "static/media/shish-kebab.f0e21c30.svg";